export type PaidPlanSlug = 'basic' | 'pro';

const PLAN_PRIORITY: Record<PaidPlanSlug, number> = {
  basic: 1,
  pro: 2,
};

export type PlanChangeDirection = 'upgrade' | 'downgrade' | 'none';

export interface PlanChangeDecision {
  effectiveImmediately: boolean;
  deferredEffectiveAt: string | null;
  direction: PlanChangeDirection;
}

interface PlanChangeInput {
  currentPlan?: PaidPlanSlug | null;
  targetPlan: PaidPlanSlug;
  currentPeriodEnd?: string | null;
}

function resolveDirection(
  currentPlan: PaidPlanSlug | null | undefined,
  targetPlan: PaidPlanSlug,
): PlanChangeDirection {
  if (!currentPlan) {
    return 'upgrade';
  }

  const currentPriority = PLAN_PRIORITY[currentPlan];
  const targetPriority = PLAN_PRIORITY[targetPlan];

  if (targetPriority > currentPriority) {
    return 'upgrade';
  }
  if (targetPriority < currentPriority) {
    return 'downgrade';
  }
  return 'none';
}

export function shouldPreviewPaidPlanChange(
  currentPlan: PaidPlanSlug | null | undefined,
  targetPlan: PaidPlanSlug,
): boolean {
  return currentPlan !== null && currentPlan !== undefined && currentPlan !== targetPlan;
}

export function determinePlanChangeBehavior({
  currentPlan,
  targetPlan,
  currentPeriodEnd,
}: PlanChangeInput): PlanChangeDecision {
  const direction = resolveDirection(currentPlan, targetPlan);

  if (direction === 'downgrade') {
    return {
      direction,
      effectiveImmediately: false,
      deferredEffectiveAt: currentPeriodEnd ?? null,
    };
  }

  return {
    direction,
    effectiveImmediately: true,
    deferredEffectiveAt: null,
  };
}
